import { createRouter, createWebHistory } from "vue-router";
import { session } from "./data/session";
import { canAccessRoute, defaultRouteForPermissions } from "./data/vendorPortal";

const routes = [
	{
		path: "/",
		redirect: "/account/login",
	},
	{
		path: "/account/login",
		name: "Login",
		component: () => import("./pages/Login.vue"),
	},
	{
		path: "/dashboard",
		name: "Dashboard",
		component: () => import("./pages/Dashboard.vue"),
	},
	{
		path: "/visits",
		name: "Visits",
		component: () => import("./pages/Visits.vue"),
	},
	{
		path: "/contracts",
		name: "Contracts",
		component: () => import("./pages/Contracts.vue"),
	},
	{
		path: "/contracts/:name",
		name: "ContractDetail",
		component: () => import("./pages/ContractDetail.vue"),
		props: true,
	},
	{
		path: "/invoices",
		name: "Invoices",
		component: () => import("./pages/Invoices.vue"),
	},
	{
		path: "/invoices/:name",
		name: "InvoiceDetail",
		component: () => import("./pages/InvoiceDetail.vue"),
		props: true,
	},
	{
		path: "/soa",
		name: "SOA",
		component: () => import("./pages/SOA.vue"),
	},
	{
		path: "/users",
		name: "Users",
		component: () => import("./pages/Users.vue"),
	},
	{
		path: "/visits/:name/rectifications/new",
		name: "RaiseRectification",
		component: () => import("./pages/RaiseRectification.vue"),
		props: true,
	},
	{
		path: "/visits/:name",
		name: "VisitDetail",
		component: () => import("./pages/VisitDetail.vue"),
		props: true,
	},
	{
		path: "/profile",
		name: "Profile",
		component: () => import("./pages/Profile.vue"),
	},
	{
		path: "/:pathMatch(.*)*",
		redirect: "/account/login",
	},
];

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
});

router.beforeEach(async (to) => {
	let isLoggedIn = session.isLoggedIn;

	if (to.name !== "Login" && !isLoggedIn) {
		return { name: "Login" };
	}

	if (isLoggedIn) {
		await session.ensureAccess();
		isLoggedIn = session.isLoggedIn;
	}

	if (to.name !== "Login" && !isLoggedIn) {
		return { name: "Login" };
	}

	if (to.name === "Login" && isLoggedIn) {
		return { name: defaultRouteForPermissions(session.permissions) };
	}

	if (to.name !== "Login" && !canAccessRoute(to.name, session.permissions)) {
		return { name: defaultRouteForPermissions(session.permissions) };
	}
});

export default router;
